import React from 'react'

export interface ToolbarProps {
    children: React.ReactNode
    orientation?: 'horizontal' | 'vertical'
    isAttached?: boolean
    style?: React.CSSProperties
}

export const Toolbar = ({ children, orientation = 'horizontal', isAttached = true, style }: ToolbarProps) => {
    const isVertical = orientation === 'vertical'

    return (
        <div
            role="toolbar"
            aria-orientation={orientation}
            className={`inline-flex items-center gap-0 ${isVertical ? 'flex-col' : 'flex-row'} ${isAttached ? 'rounded-3xl bg-surface p-1 shadow-overlay' : ''}`}
            style={style}
        >
            {children}
        </div>
    )
}
